/** Aba Histórico: o que foi impresso, quando e por quem (uma linha por lote em cada envio). */
import React, { useEffect, useState } from "react";

import { EmptyStateErro } from "../../components/EmptyState";
import { IDS_DA_MATRIZ, setorPorId } from "../../utils/apontamentos";
import { Bloco, TabelaHistorico, Vazio } from "./styles";

const FORMATOS = { impressao: "Impressão", pdf: "PDF", imagem: "Imagem" };
const DATA_HORA = new Intl.DateTimeFormat("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });

/**
 * Junta os setores de um mesmo envio (mesmo lote, pessoa, formato e minuto).
 * O backend não tem id de envio: se o setor já está no grupo, é outro envio
 * no mesmo minuto e abre uma linha nova.
 */
export function agruparEnvios(itens) {
  const grupos = [];
  const abertos = new Map();
  itens.forEach((item) => {
    const chave = `${String(item.criado_em).slice(0, 16)}|${item.lote_chave}|${item.usuario_nome}|${item.formato}`;
    let grupo = abertos.get(chave);
    if (!grupo || grupo.setores.includes(item.setor)) {
      grupo = { ...item, setores: [], vias: [] };
      abertos.set(chave, grupo);
      grupos.push(grupo);
    }
    grupo.setores.push(item.setor);
    grupo.vias.push(item.via);
  });
  return grupos;
}

function descreverVia(vias) {
  const maior = Math.max(...vias);
  return maior === 1 ? "Original" : `${maior}ª via`;
}

export default function Historico({ listar }) {
  const [itens, setItens] = useState(null);
  const [erro, setErro] = useState(null);

  useEffect(() => {
    let ativo = true;
    listar()
      .then((lista) => ativo && setItens(agruparEnvios(lista)))
      .catch((falha) => ativo && setErro(falha));
    return () => {
      ativo = false;
    };
  }, [listar]);

  if (erro) return <EmptyStateErro erro={erro} />;

  return (
    <Bloco aria-labelledby="titulo-historico">
      <header>
        <h2 id="titulo-historico">Impressões registradas</h2>
      </header>
      {itens === null && <Vazio>Carregando…</Vazio>}
      {itens?.length === 0 && <Vazio>Nenhuma impressão registrada ainda.</Vazio>}
      {itens?.length > 0 && (
        <TabelaHistorico>
          <thead>
            <tr>
              <th style={{ width: 140 }}>Quando</th>
              <th style={{ width: "22%" }}>Lote</th>
              <th>Setores</th>
              <th className="some-no-celular" style={{ width: 90 }}>Formato</th>
              <th className="some-no-celular" style={{ width: 90 }}>Via</th>
              <th className="some-no-celular" style={{ width: "18%" }}>Por</th>
            </tr>
          </thead>
          <tbody>
            {itens.map((envio) => {
              const setores = IDS_DA_MATRIZ.filter((id) => envio.setores.includes(id)).map((id) => setorPorId(id).curto).join(", ");
              return (
                <tr key={`${envio.criado_em}|${envio.lote_chave}|${envio.formato}|${envio.usuario_nome}`}>
                  <td>{DATA_HORA.format(new Date(envio.criado_em))}</td>
                  <td className="mono" title={envio.lote_rotulo}>{envio.lote_rotulo}</td>
                  <td title={setores}>{setores}</td>
                  <td className="some-no-celular">{FORMATOS[envio.formato] || envio.formato}</td>
                  <td className="some-no-celular">{descreverVia(envio.vias)}</td>
                  <td className="some-no-celular" title={envio.usuario_nome}>{envio.usuario_nome || "—"}</td>
                </tr>
              );
            })}
          </tbody>
        </TabelaHistorico>
      )}
    </Bloco>
  );
}
